import { render, staticRenderFns } from "./MenuHome.vue?vue&type=template&id=e621b340"
import script from "./MenuHome.vue?vue&type=script&lang=js"
export * from "./MenuHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports